import { render, staticRenderFns } from "./scrotalSummary.vue?vue&type=template&id=e24130f4&scoped=true&"
import script from "./scrotalSummary.vue?vue&type=script&lang=js&"
export * from "./scrotalSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24130f4",
  null
  
)

export default component.exports